import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const CTAButton = ({ text = "GET STARTED NOW", className = "" }) => {
  const checkoutUrl = "https://digitalrevenue.mysamcart.com/checkout/retirement-income-e-book#samcart-slide-open-right";

  return (
    <motion.a
      whileHover={{ scale: 1.03, y: -2 }}
      whileTap={{ scale: 0.98 }}
      href={checkoutUrl}
      className={`group relative inline-flex items-center justify-center gap-4 px-12 py-6 bg-brand-green text-white font-bold text-xl md:text-2xl rounded-full shadow-cta hover:bg-brand-hover transition-all duration-300 w-full sm:w-auto text-center ${className}`}
    >
      <span>{text}</span>
      <SafeIcon icon={FiArrowRight} className="text-2xl group-hover:translate-x-1 transition-transform" />
    </motion.a>
  );
};

export default CTAButton;